/** Shown in “Other Analyses / Instructions” (matches legacy static form text). */
export const QC_OTHER_ANALYSES_FAX_BOILERPLATE =
  'SVP FAXER AU 1-855-952-2436 AUCUN ACCES AU DSQ MERCI';

export const QC_WL_DEFAULT_VALUE = ({ user, customer }) => ({
  profiles: {
    LIPID: true
  },
  individualAnalyses: {
    ALB: true,
    ALK: true,
    ALT: true,
    CREA: true,
    LYTES: true,
    CRP: true,
    FERI: true,
    AC: true,
    CBC: true,
    HBA1CP: true,
    LIP: true,
    TSH: true,
    B12: true
  },
  testSpecification: {
    other_analyses_instructions: QC_OTHER_ANALYSES_FAX_BOILERPLATE
  }
});

export const QC_TRT_DEFAULT_VALUE = ({ user, customer }) => ({
  profiles: {
    LIPID: true
  },
  individualAnalyses: {
    ALB: true,
    ALK: true,
    ALT: true,
    CREA: true,
    LYTES: true,
    CRP: true,
    ESTRA: true,
    FERI: true,
    FSH: true,
    AC: true,
    CBC: true,
    HBA1CP: true,
    LIP: true,
    LH: true,
    PROL: true,
    PSA: true,
    TESLI: true,
    TEST: true,
    TSH: true,
    B12: true
  },
  testSpecification: {
    other_analyses_instructions: QC_OTHER_ANALYSES_FAX_BOILERPLATE
  }
});

export const QC_LGV_DEFAULT_VALUE = ({ user, customer, organization }) => {
  const jackLgvOtherAnalyses = 'Total Insulin, Lipoprotein(a), Nucleated RBC (NRBC)';
  const jillLgvOtherAnalyses = 'DHEA-S, Total Insulin, Lipoprotein(a), Nucleated RBC (NRBC)';
  const defaultsByProfile = {
    jack_health: {
      ...QC_TRT_DEFAULT_VALUE({ user, customer }),
      profiles: {
        ...QC_TRT_DEFAULT_VALUE({ user, customer }).profiles,
        TIBCP: true,
        FERT2: true
      },
      individualAnalyses: {
        ...QC_TRT_DEFAULT_VALUE({ user, customer }).individualAnalyses,
        FSH: false,
        LH: false,
        PROL: false,
        APOA: false,
        AST: true,
        CORTIAM: true,
        MG: true,
        LHOMO: false,
        URIC: true,
        T3F: true,
        T4F: true,
        CA: true,
        PHOS: true,
        GGT: true,
        PSA: false
      },
      testSpecification: {
        other_analyses_instructions: `${QC_OTHER_ANALYSES_FAX_BOILERPLATE}\n\n${jackLgvOtherAnalyses}`
      }
    },
    jill_health: {
      ...QC_WL_DEFAULT_VALUE({ user, customer }),
      profiles: {
        ...QC_WL_DEFAULT_VALUE({ user, customer }).profiles,
        TIBCP: true,
        FERT2: true
      },
      individualAnalyses: {
        ...QC_WL_DEFAULT_VALUE({ user, customer }).individualAnalyses,
        FSH: false,
        LH: false,
        PROL: false,
        PROG: true,
        ESTRA: true,
        TEST: true,
        T3F: true,
        T4F: true,
        CA: true,
        PHOS: true,
        GGT: true,
        MG: true,
        URIC: true,
        AST: true,
        CORTIAM: true,
        APOA: false,
        APOB: true
      },
      testSpecification: {
        other_analyses_instructions: `${QC_OTHER_ANALYSES_FAX_BOILERPLATE}\n\n${jillLgvOtherAnalyses}`
      }
    }
  };
  const normalizedGender = customer?.gender?.toLowerCase?.();
  if (normalizedGender === 'male' || normalizedGender === 'm') {
    return defaultsByProfile.jack_health;
  }
  if (normalizedGender === 'female' || normalizedGender === 'f') {
    return defaultsByProfile.jill_health;
  }
  return defaultsByProfile[organization] || defaultsByProfile.jack_health;
};
